import { useState } from 'react';

type UseTabsFormOnlyProps = {
  initialTabValue?: number;
};
export const useTabsFormOnly = ({
  initialTabValue = 1,
}: UseTabsFormOnlyProps = {}) => {
  const [valueTab, setValueTab] = useState(initialTabValue);
  const handleMethodChange = (_event: any, newValue: number) => {
    setValueTab(newValue);
  };

  const [valueTab2, setValueTab2] = useState(initialTabValue);
  const handleMethodChange2 = (_event: any, newValue: number) => {
    setValueTab2(newValue);
  };

  return {
    setValueTab,
    valueTab,
    handleMethodChange,

    valueTab2,
    handleMethodChange2,
  };
};
